import Vue from "vue";
import router from "@/router";
import store from "@/store";
import cryptoJs from 'crypto-js'
let keyOne = 'pinming@20180821'
// 加密函數
export function aesEncrypt(word, aesSecrect) {
  if (aesSecrect === undefined || aesSecrect == '') {
    aesSecrect = keyOne
  }
  let key = cryptoJs.enc.Utf8.parse(aesSecrect)
  let enc = ''

  enc = cryptoJs.AES.encrypt(word, key, {
    iv: cryptoJs.enc.Utf8.parse(aesSecrect.substr(0, 16)),
    mode: cryptoJs.mode.CBC,
    padding: cryptoJs.pad.Pkcs7
  })
  let encResult = enc.toString()
  return encResult
}

/**
 * 解密函數
 * @param {*} word
 */
export function  aesDecrypt(word, aesSecrect) {
  if (aesSecrect === undefined || aesSecrect == '') {
    aesSecrect = keyOne
  }
  let key = cryptoJs.enc.Utf8.parse(aesSecrect)
  let dec = cryptoJs.AES.decrypt(word, key, {
    iv: cryptoJs.enc.Utf8.parse(aesSecrect.substr(0, 16)),
    mode: cryptoJs.mode.CBC,
    padding: cryptoJs.pad.Pkcs7
  })
  let decData = cryptoJs.enc.Utf8.stringify(dec)
  return decData
}

/**
 * 获取uuid
 */
export function getUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    return (c === "x" ? (Math.random() * 16) | 0 : "r&0x3" | "0x8").toString(
      16
    );
  });
}


export function formatSuiteDictOptionsData(arr,unshiftData) {
  let dataArr = [];
  if(unshiftData)dataArr.push(unshiftData);
  arr.forEach(item=>{
    if(item.id){
      dataArr.push({
        id: item.id,
        value: item.value,
        label: item.name
      })
    }
  })
  return dataArr
}
/**
 * 回滚到顶部
 */
export function scrollToTop(callback) {
  let timer = null;
  cancelAnimationFrame(timer);
  timer = requestAnimationFrame(function fn() {
    let documentScrollTop = document.documentElement.scrollTop;
    if (documentScrollTop > 5000) {
      documentScrollTop -= 1000;
      document.documentElement.scrollTop = documentScrollTop;
      timer = requestAnimationFrame(fn);
    } else if (documentScrollTop > 1000 && documentScrollTop <= 5000) {
      documentScrollTop -= 500;
      document.documentElement.scrollTop = documentScrollTop;
      timer = requestAnimationFrame(fn);
    } else if (documentScrollTop > 200 && documentScrollTop <= 1000) {
      documentScrollTop -= 100;
      document.documentElement.scrollTop = documentScrollTop;
      timer = requestAnimationFrame(fn);
    } else if (documentScrollTop > 50 && documentScrollTop <= 200) {
      documentScrollTop -= 10;
      document.documentElement.scrollTop = documentScrollTop;
      timer = requestAnimationFrame(fn);
    } else if (documentScrollTop > 0 && documentScrollTop <= 50) {
      documentScrollTop -= 5;
      document.documentElement.scrollTop = documentScrollTop;
      timer = requestAnimationFrame(fn);
    } else {
      cancelAnimationFrame(timer);
      if (callback) callback();
    }
  });
}

/**
 * tag 标签类型转换
 * @param type
 * @param key
 * @returns {*}
 */
export function formatterTagType(type, key) {
  if (key == "witnessStatus") {
    switch (type) {
      case 1:
        return "";
        break;
      case 2:
        return "success";
        break;
      case 3:
        return "danger";
        break;
    }
  }

  if (key == "personRole") {
    switch (type) {
      case 1:
        return "";
        break;
      case 2:
        return "danger";
        break;
      case 3:
        return "warning";
        break;
      case 4:
        return "success";
        break;
      case 5:
        return "success";
        break;
      case 9:
        return "info";
        break;
    }
  }

  if (key == "projectType") {
    switch (type) {
      case "GC":
        return "danger";
        break;
      case "CG":
        return "success";
        break;
      case "GT":
        return "";
        break;
      case "CQ":
        return "warning";
        break;
      case "QT":
        return "info";
        break;
    }
  }

  if (key == "roleType") {
    switch (type) {
      case "1":
        return "";
        break;
      case "2":
        return "success";
        break;
      case "3":
        return "warning";
        break;
      case "4":
        return "danger";
        break;
      case "9":
        return "info";
        break;
    }
  }

  if (key == "cateQuestState") {
    switch (type) {
      case -1:
        return "info";
        break;
      case 1:
        return "success";
        break;
      case 0:
        return "";
        break;
    }
  }

  return "";
}

export function formatterDataDictionary(list, value) {
  const item = list.filter((sl) => sl.value == value)[0];
  return item != null ? item.name : "";
}

/**
 * 格式化日期
 * @param date
 * @param fmt
 * @returns {string}
 */
export function formatDate(date, fmt) {
  if (date == null) {
    return "";
  }
  if (!(date instanceof Date)) {
    date = new Date(date.replace(/-/g, "/"));
  }

  let str = fmt
    .replace("yyyy", date.getFullYear())
    .replace("MM", parseIntforLen(date.getMonth() + 1, 2))
    .replace("dd", parseIntforLen(date.getDate(), 2))
    .replace("HH", parseIntforLen(date.getHours(), 2))
    .replace("mm", parseIntforLen(date.getMinutes(), 2))
    .replace("ss", parseIntforLen(date.getSeconds(), 2));
  return str;
}

/**
 * 格式化数字 补零
 * @param num
 * @param len
 * @returns {*}
 */
export function parseIntforLen(num, len) {
  if (String(num).length > len) return num;
  return (Array(len).join(0) + num).slice(-len);
}

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth(key) {
  return (
    JSON.parse(sessionStorage.getItem("permissions") || "[]").indexOf(key) !==
      -1 || false
  );
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = "id", pid = "parentId") {
  var res = [];
  var temp = {};
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i];
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]["children"]) {
        temp[data[k][pid]]["children"] = [];
      }
      if (!temp[data[k][pid]]["_level"]) {
        temp[data[k][pid]]["_level"] = 1;
      }
      data[k]["_level"] = temp[data[k][pid]]._level + 1;
      temp[data[k][pid]]["children"].push(data[k]);
    } else {
      res.push(data[k]);
    }
  }
  return res;
}

/**
 * 清除登录信息
 */
export function clearLoginInfo() {
  Vue.cookie.delete(window.SITE_CONFIG.uid);
  store.commit("resetStore");
  router.options.isAddDynamicMenuRoutes = false;
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区(只有在时间重新构造时才处理)
 * @param date
 */
export function parseToDate(date) {
  if (date === undefined || date === null) {
    date = new Date();
  } else if (date instanceof Date) {
    return date;
  } else {
    date = new Date(date);
  }
  return new Date(date - date.getTimezoneOffset());
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区
 * @param date
 * @param useRaw
 */
export function getMonth(date, useRaw) {
  return parseToDate(date).getMonth() + 1;
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区
 * @param date 当前时间
 * @param offsetMonth 月份便宜
 */
export function getFullMonth(date, offsetMonth) {
  var cur = parseToDate(date);
  if (offsetMonth !== undefined && offsetMonth !== 0) {
    cur = addMonth(cur, offsetMonth);
  }
  return cur.getFullYear() * 100 + cur.getMonth() + 1;
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区
 * @param date
 */
export function getYear(date) {
  return parseToDate(date).getFullYear();
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区
 * @param date
 * @param count
 */
export function addMonth(date, count) {
  var newDate;
  if (date instanceof Date) {
    newDate = new Date(date);
  } else {
    newDate = new Date(parseToDate(date));
  }
  newDate.setMonth(newDate.getMonth() + count);
  return newDate;
}

//设置默认日期
export function getMonthPickDefaultDate() {
  //获取新的时间(2019.4.12）
  let date = parseToDate();
  let fromDate = addMonth(date, -6);
  let endDate = addMonth(date, 1);
  //字符串拼接，开始时间，结束时间
  var month = fromDate.getMonth() + 1;
  let beg = fromDate.getFullYear() + "-" + (month < 10 ? "0" : "") + month;
  month = endDate.getMonth() + 1;
  let end = endDate.getFullYear() + "-" + (month < 10 ? "0" : "") + month;
  return [beg, end]; //将值设置给插件绑定的数据
}

/**
 * 将日期选择的月度范围 转换为 统计要求的 [20190101,20190101]格式
 * @param value
 */
export function parseMonthPickValue(value) {
  if (
    value === undefined ||
    value.length < 2 ||
    value[0] === undefined ||
    value[1] === undefined
  ) {
    value = getMonthPickDefaultDate();
  }
  var fromDate = value[0];
  var endDate = value[1];
  let result = {};
  if (fromDate.length <= 7) {
    fromDate = fromDate + "-" + "01";
    result.from = getFullMonth(fromDate);
  } else {
    result.from = getFullMonth(new Date(fromDate));
  }
  if (endDate.length <= 7) {
    endDate = endDate + "-" + "01";
    result.end = getFullMonth(endDate, 1);
  } else {
    result.end = getFullMonth(new Date(endDate), 1);
  }
  return result;
}

/**
 * JS获取URL中参数值
 * @param name
 * @returns {string|null}
 */
export function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

// 获取系统信息
export function getOsInfo() {
  var userAgent = navigator.userAgent.toLowerCase();
  var name = "Unknown";
  var version = "Unknown";
  if (userAgent.indexOf("win") > -1) {
    name = "Windows";
    if (userAgent.indexOf("windows nt 5.0") > -1) {
      version = "Windows 2000";
    } else if (
      userAgent.indexOf("windows nt 5.1") > -1 ||
      userAgent.indexOf("windows nt 5.2") > -1
    ) {
      version = "Windows XP";
    } else if (userAgent.indexOf("windows nt 6.0") > -1) {
      version = "Windows Vista";
    } else if (
      userAgent.indexOf("windows nt 6.1") > -1 ||
      userAgent.indexOf("windows 7") > -1
    ) {
      version = "Windows 7";
    } else if (
      userAgent.indexOf("windows nt 6.2") > -1 ||
      userAgent.indexOf("windows 8") > -1
    ) {
      version = "Windows 8";
    } else if (userAgent.indexOf("windows nt 6.3") > -1) {
      version = "Windows 8.1";
    } else if (
      userAgent.indexOf("windows nt 6.2") > -1 ||
      userAgent.indexOf("windows nt 10.0") > -1
    ) {
      version = "Windows 10";
    } else {
      version = "Unknown";
    }
  } else if (userAgent.indexOf("iphone") > -1) {
    name = "Iphone";
  } else if (userAgent.indexOf("mac") > -1) {
    name = "Mac";
  } else if (
    userAgent.indexOf("x11") > -1 ||
    userAgent.indexOf("unix") > -1 ||
    userAgent.indexOf("sunname") > -1 ||
    userAgent.indexOf("bsd") > -1
  ) {
    name = "Unix";
  } else if (userAgent.indexOf("linux") > -1) {
    if (userAgent.indexOf("android") > -1) {
      name = "Android";
    } else {
      name = "Linux";
    }
  } else {
    name = "Unknown";
  }
  return { name, version };
}

export function IEVersion() {
  var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
  var isIE =
    userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
  var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
  var isIE11 =
    userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
  if (isIE) {
    var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    reIE.test(userAgent);
    var fIEVersion = parseFloat(RegExp["$1"]);
    if (fIEVersion == 7) {
      return 7;
    } else if (fIEVersion == 8) {
      return 8;
    } else if (fIEVersion == 9) {
      return 9;
    } else if (fIEVersion == 10) {
      return 10;
    } else {
      return 6; //IE版本<=7
    }
  } else if (isEdge) {
    return "edge"; //edge
  } else if (isIE11) {
    return 11; //IE11
  } else {
    return -1; //不是ie浏览器
  }
}

//是否IE浏览器
export function isIEBrowser() {
  let IEV = IEVersion();
  return IEV > -1 ? true : false;
}
/**
 * 设置SessionStorage
 */
export function setSessionStorage  (key, val){
    if (key) {
        let obj = JSON.stringify(val);
        sessionStorage.setItem(key, obj)
    }
}
/**
 * 获取SessionStorage
 */
export function getSessionStorage (key){
    let val = sessionStorage.getItem(key);
    return val ? JSON.parse(val) : false;
}
export function IsIE() {
  //判断是否为IE内核浏览器
  var u = window.navigator.userAgent.toLocaleLowerCase();
  var msie = /(msie) ([\d.]+)/;
  var chrome = /(chrome)\/([\d.]+)/;
  var firefox = /(firefox)\/([\d.]+)/;
  var safari = /(safari)\/([\d.]+)/;
  var opera = /(opera)\/([\d.]+)/;
  var ie11 = /(trident)\/([\d.]+)/;
  var b =
    u.match(msie) ||
    u.match(chrome) ||
    u.match(firefox) ||
    u.match(safari) ||
    u.match(opera) ||
    u.match(ie11);
  if (b[1] == "msie" || b[1] == "trident") {
    return true;
  } else {
    return false;
  }
}

//是否Firefox浏览器
export function isFirefoxBrowser() {
  //判断是否为Firefox内核浏览器
  var u = window.navigator.userAgent.toLocaleLowerCase();

  var firefox = /(firefox)\/([\d.]+)/;
  var b = u.match(firefox);
  if (b) {
    return true;
  } else {
    return false;
  }
}

// 插入iframe
export function iframeInsert($el) {
  if (isIEBrowser()) {
    let html =
      '<iframe style="position:absolute;z-index:-1;width:100%;height:100%;top:0;left:0;right:0;bottom:0" allowtransparency="true" src="" frameborder="0"></iframe>';
    $el.querySelector(".el-dialog").insertAdjacentHTML("afterbegin", html);
  }
}

export function nearSixYearsList(currentYear) {
  let yearsList = [],
    thisYear = new Date().getFullYear();
  if (thisYear - currentYear == 0) {
    for (var i = 0; i < 6; i++) {
      yearsList.push(currentYear - i);
    }
  } else if (thisYear - currentYear == 1) {
    for (var j = 0; j < 5; j++) {
      yearsList.push(currentYear - j);
    }
    yearsList.unshift(currentYear + 1);
  } else {
    for (var k = 0; k < 4; k++) {
      yearsList.push(currentYear - k);
    }
    yearsList.unshift(currentYear + 1);
    yearsList.unshift(currentYear + 2);
  }
  return yearsList;
}

// 鼠标移入显示滚轮
export function mouseIn($event) {
  let className = $event.currentTarget.className;
  let temp = className.split("scroll_hidden");
  temp = temp.join("").replace(/(\s*$)/g, "");
  $event.currentTarget.className = temp;
}
// 鼠标移出隐藏滚轮
export function mouseOut($event) {
  let className = $event.currentTarget.className;
  if (className.indexOf("scroll_hidden") != -1) {
    return;
  } else {
    $event.currentTarget.className = className + " scroll_hidden";
  }
}

export const navList = [
  { value: "GC", label: "工程建设" },
  { value: "CG", label: "政府采购" },
  { value: "GT", label: "国土交易" },
  { value: "CQ", label: "国有产权" },
  { value: "XT", label: "协同办公" },
  { value: "QT", label: "其他" },
];

// 金额单位关联 1元 2万元 3亿元
export const moneyUnit = {
    1: "元",
    2: "万元",
    3: "亿元",
}

export function getNewTime() {
  var myDate = new Date();
  var year = myDate.getFullYear(); //获取当前年
  var mon = myDate.getMonth() + 1; //获取当前月
  var date = myDate.getDate(); //获取当前日
  var hours = myDate.getHours(); //获取当前小时
  var minutes = myDate.getMinutes(); //获取当前分钟
  var seconds = myDate.getSeconds(); //获取当前秒
  let now = "";
  if (isIEBrowser()) {
    now =
      year +
      "/" +
      mon +
      "/" +
      date +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds;
  } else {
    now =
      year +
      "-" +
      mon +
      "-" +
      date +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds;
  }
  return now;
}

export function timeTrasnform(datetime, formatStr){
  let dat = datetime;
  let str = formatStr;
  let Week = ['日', '一', '二', '三', '四', '五', '六'];
  str = str.replace(/yyyy|YYYY/, dat.getFullYear());
  str = str.replace(/yy|YY/, (dat.getYear() % 100) > 9 ? (dat.getYear() % 100).toString() : '0' + (dat.getYear() % 100));
  str = str.replace(/MM/, dat.getMonth() > 9 ? (dat.getMonth() + 1).toString() : '0' + (dat.getMonth() + 1));
  str = str.replace(/M/g, (dat.getMonth() + 1));
  str = str.replace(/w|W/g, Week[dat.getDay()]);
  str = str.replace(/dd|DD/, dat.getDate() > 9 ? dat.getDate().toString() : '0' + dat.getDate());
  str = str.replace(/d|D/g, dat.getDate());
  str = str.replace(/hh|HH/, dat.getHours() > 9 ? dat.getHours().toString() : '0' + dat.getHours());
  str = str.replace(/h|H/g, dat.getHours());
  str = str.replace(/mm/, dat.getMinutes() > 9 ? dat.getMinutes().toString() : '0' + dat.getMinutes());
  str = str.replace(/m/g, dat.getMinutes());
  str = str.replace(/ss|SS/, dat.getSeconds() > 9 ? dat.getSeconds().toString() : '0' + dat.getSeconds());
  str = str.replace(/s|S/g, dat.getSeconds());
  return str
}

export function group(array, subGroupLength){
  let index = 0;
  let newArray = [];
  while(index < array.length) {
    var childArr=array.slice(index, index += subGroupLength);
    // if(childArr.length<subGroupLength){
    // 	var len=subGroupLength-childArr.length;
    // 	for(let i=0;i<len;i++){
    // 		childArr.push({});
    // 	}
    // }
    newArray.push(childArr);
  }
  return newArray;
}
export function formattDictionaryData(list,key,targetProp,returnProp) {
  if(list && targetProp && returnProp){
    const item = list.filter(sl => sl[targetProp] == key)[0];
    return item != null ? item[returnProp] : "";
  }else{
    return ''
  }

}

export const getProjectUrl = (id) => {
  return `/businessflowWitness/list_detail?businessType=GC&id=${id}&purchaserMode=`
}

// 从 URL 中提取参数
export function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
// 获取token信息
export function getToken () {
  return Vue.cookie.get('access_token') || Vue.cookie.get('oauth_access_token')
}